import React, { useState, useEffect } from 'react'
import { Tree as AntdTree } from 'antd'
import type { DataNode, TreeProps } from 'antd/es/tree'
import 'antd/dist/antd.css'
import styled from 'styled-components'
import i18n from 'live/services/i18n'
import { removeDuplicatesBy, removeDuplicates } from '../../utils/utils'

type IProps = {
    data: DataNode[]
    checked?: React.Key[]
    emptyMsg?: string
    callback(keysActive: React.Key[]): void
    selectAll?: () => void
    deselectAll?: () => void
}

const Tree = ({ data = [], emptyMsg = 'Not found data', checked, callback, selectAll, deselectAll }: IProps) => {
    const dataUnique = removeDuplicatesBy(data, 'title')
    const onCheck = (checkedKeys: React.Key[], info, selected: string) => {
        let checkedTitleList = Object.assign([], removeDuplicates(checkedKeys))
        if (selected) {
            if (checkedTitleList.includes(selected)) checkedTitleList = checkedTitleList.filter(i => i !== selected)
            else checkedTitleList.push(selected)
        }
        if (checkedTitleList.length > 0 && checkedTitleList.length == dataUnique.length) {
            selectAll()
        }
        else {
            deselectAll()
        }
        setCheckedKeys(checkedTitleList)
        callback(checkedTitleList)
    }

    const [checkedKeys, setCheckedKeys] = useState<React.Key[]>([])

    useEffect(() => {
        setCheckedKeys(checked)
    }, [checked])

    return (
        <Wrapper>
            {data.length > 0 ? (
                <WrapperAntdTree
                    onClick={(e) => {
                        onCheck(checkedKeys, {}, e.target.innerHTML)
                    }}
                    checkable
                    defaultExpandAll={true}
                    checkedKeys={checkedKeys}
                    onCheck={onCheck}
                    treeData={dataUnique}
                    treeCheckable
                />
            ) : (
                <span className="empty-msg">{i18n(emptyMsg)}</span>
            )}
        </Wrapper>
    )
}

export default Tree

const Wrapper = styled.div`
    .empty-msg {
        overflow: hidden;
        color: ${({ theme }) => theme['gray-600']};
        text-overflow: ellipsis;
        font-family: ${({ theme }) => theme['font-regular']};
        font-size: 13px;
        font-style: italic;
        font-weight: 400;
    }
`

const WrapperAntdTree = styled(AntdTree)`
    .ant-tree-switcher,
    .ant-tree-switcher-icon {
        display: none !important;
    }

    .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
        background-color: ${({ theme }) => theme['blue-500']};
        border-color: ${({ theme }) => theme['blue-500']};
    }
`
